<template>
  <div class="delete-condition-modal-wrapper">
    <div class="modal task">
      <div class="modal-close" @click="close"></div>
      <div class="content">
        <div class="tab">
          <div class="delete-condition-modal">
            <div class="delete-condition-modal-title">
              How should we handle the following task?
            </div>
            <div class="inner-wrap">
              <div class="condition-options">
                <ul class="popup-list">
                  <li @click="removeCondition()">
                    <div class="content-wrap">
                      <div class="condition-img">
                        <img
                          src="../../assets/img/remove-both-block.png"
                          alt=""
                        />
                      </div>
                      <div class="figure-caption">
                        1. {{ deleteOptions['delete'] }}
                      </div>
                    </div>
                  </li>
                  <li
                    v-if="
                      findExistingPath() === true ||
                      findExistingPath() === 'both'
                    "
                    @click="removeCondition('true')"
                  >
                    <div class="content-wrap">
                      <div class="condition-img">
                        <img
                          src="../../assets/img/remove-false-block.png"
                          alt=""
                        />
                      </div>
                      <div class="figure-caption">
                        2. {{ deleteOptions['true'] }}
                      </div>
                    </div>
                  </li>
                  <li
                    v-if="
                      findExistingPath() === false ||
                      findExistingPath() === 'both'
                    "
                    @click="removeCondition('false')"
                  >
                    <div class="content-wrap">
                      <div class="condition-img">
                        <img
                          src="../../assets/img/remove-true-block.png"
                          alt=""
                        />
                      </div>
                      <div class="figure-caption">
                        3. {{ deleteOptions['false'] }}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeleteConditionModal',
  data() {
    return {
      deleteOptions: {
        delete: 'Alle folgenden Aufgaben löschen',
        true: 'Den richtigen Pfad beibehalten',
        false: 'Den falschen Pfad beibehalten',
      },
    };
  },
  props: {
    tasks: { type: Array, required: true },
    conditionID: { type: Number, required: true },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    findExistingPath() {
      const conditionPath = this.tasks.filter(
        (item) => item.previousTaskId === this.conditionID
      );
      if (conditionPath.length === 2) {
        return 'both';
      } else {
        if (conditionPath[0].pathType.toString() === 'true') {
          return true;
        } else if (conditionPath[0].pathType.toString() === 'false') {
          return false;
        }
      }
    },
    removeCondition(identifier) {
      let copyTasks = JSON.parse(JSON.stringify(this.tasks));
      const currentTaskIndex = copyTasks.findIndex(
        (el) => el.id === this.conditionID
      );
      const removedTask = copyTasks[currentTaskIndex];

      const deleteTaskAndChildren = (tasks, taskId, type) => {
        const taskIndex = tasks.findIndex((task) => task.id === taskId);
        if (taskIndex === -1) return tasks;

        let children = tasks.filter((task) => task.previousTaskId === taskId);

        if (type) {
          children = children.filter(
            (task) => task.pathType.toString() !== type
          );

          const currentPathChild = tasks.find(
            (el) =>
              el.previousTaskId === taskId && el.pathType.toString() == type
          );

          if (currentPathChild) {
            tasks = tasks.map((el) => {
              if (el.id == currentPathChild.id) {
                let element = { ...el };
                if (removedTask.id === tasks[taskIndex].id) {
                  const deleteTaskParentTask = tasks.find(
                    (task) => task.id === tasks[taskIndex].previousTaskId
                  );
                  if (deleteTaskParentTask?.name !== 'Condition') {
                    delete element.pathType;
                  } else if (removedTask.hasOwnProperty('pathType')) {
                    element.pathType = removedTask.pathType;
                  }
                } else {
                  delete element.pathType;
                }
                element.previousTaskId = tasks[taskIndex].previousTaskId;
                return element;
              }
              return el;
            });
          }
        }

        tasks.splice(taskIndex, 1);

        for (let child of children) {
          tasks = deleteTaskAndChildren(tasks, child.id);
        }

        return tasks;
      };

      const result = deleteTaskAndChildren(
        copyTasks,
        copyTasks[currentTaskIndex].id,
        identifier
      );

      this.$emit('onSelect', result);
    },
  },
};
</script>

<style scoped>
.delete-condition-modal-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal.task {
  height: fit-content !important;
  width: fit-content !important;
}
.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  height: 100%;
}

.tab {
  text-align: left;
  height: 100%;
  align-items: center;
  box-sizing: border-box;
}

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.pull-right {
  position: absolute;
  right: 0;
  top: 10px;
  z-index: 9;
  cursor: pointer;
}

.modal .btn-close {
  margin-right: 14px;
  width: 13px;
  height: 13px;
}

img {
  max-width: 100%;
}

.delete-condition-modal .inner-wrap h4 {
  font-size: 22px;
  text-align: center;
}

.delete-condition-modal .condition-options ul {
  display: flex;
  justify-content: center;
  list-style: none;
  margin: 0;
  padding: 0;
}

.delete-condition-modal .condition-options .figure-caption {
  font-size: 16px;
  color: #6c757d;
  cursor: pointer;
  font-weight: 600;
}

.delete-condition-modal .condition-options ul li {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  width: calc((100% / 3) - 10px);
  cursor: pointer;
  transition: all 300ms ease-in-out;
  border-radius: 8px;
}
.delete-condition-modal .condition-options ul li:hover {
  box-shadow: 1px 0px 8px rgba(0, 0, 0, 0.2);
}

.popup-list {
  position: relative;
  margin: 0;
  padding: 0;
  min-width: 150px;
  text-align: left;
  list-style: none;
}
.popup-list li {
  padding: 10px 15px;
  font-size: 14px;
  color: #333;
}
.delete-condition-modal-title {
  font-size: 22px;
  text-align: center;
  font-weight: 600;
  color: #333;
  margin-bottom: 30px;
}
.condition-img img {
  max-height: 350px;
}
</style>
